export default function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/hierarchy/leaves.js
// module id = ./node_modules/d3-hierarchy/src/hierarchy/leaves.js
// module chunks = 53